'use strict';

angular.module('far.ui.eventsCalendar')
.directive('eventsCalendar', function($timeout, eventsCalendarConfig) {
    function getDaysInMonth(date) {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    }

    function getWeeksInMonth(date) {
        var maxDays = getDaysInMonth(date) + getFirstDayOfMonth(date);

        return Math.ceil(maxDays / 7);
    }

    function getFirstDayOfMonth(date) {
        var firstDate = new Date(date),
            firstDayOfMonth;

        firstDate.setDate(1);
        firstDayOfMonth = firstDate.getDay();

        return firstDayOfMonth > 0 ? --firstDayOfMonth : 6;
    }

    function getMonthArray(date) {
        var weeksInMonth = getWeeksInMonth(date),
            firstDay = getFirstDayOfMonth(date),
            maxDays = getDaysInMonth(date) + firstDay,
            monthArray = [];

        for (var week = 0; week < weeksInMonth; week++) {
            var weekArray = [];

            for (var weekday = 0; weekday < 7; weekday++) {
                var monthDay = week * 7 + weekday;

                if (monthDay < firstDay) {
                    weekArray.push(null);
                    continue;
                }

                if (monthDay >= maxDays) {
                    weekArray.push(null);
                    continue;
                }

                weekArray.push(monthDay - firstDay + 1);
            }

            monthArray.push(weekArray);
        }

        return monthArray;
    }

    return {
        restrict: 'EA',
        templateUrl: '/modules/ui/events-calendar/events-calendar.html',
        scope: {
            events: '='
        },
        link: function(scope, attrs) {
            scope.maxMonths = 11;
            scope.monthDiff = 0;
            scope.days = eventsCalendarConfig.days;
            scope.month = new Date();
            scope.month.setDate(1);

            if (attrs.maxMonths && attrs.maxMonths > 0) {
                scope.maxMonths = attrs.maxMonths;
            }

            setScopeCurrentMonth();

            scope.nextMonth = function() {
                if (scope.monthDiff >= scope.maxMonths) {
                    return;
                }

                scope.monthDiff++;
                scope.month.setMonth(scope.month.getMonth() + 1);
                setScopeCurrentMonth();
            };

            scope.prevMonth = function() {
                if (scope.monthDiff == 0) {
                    return;
                }

                scope.monthDiff--;
                scope.month.setMonth(scope.month.getMonth() - 1);
                setScopeCurrentMonth();
            };

            scope.isEventsOnDate = function(day) {
                if (day == null) {
                    return false;
                }

                var monthString = (scope.month.getMonth() + 1) > 9 ? scope.month.getMonth() + 1 : ('0' + (scope.month.getMonth() + 1)),
                    dayString = day > 9 ? day : ('0' + day),
                    dateString = scope.month.getFullYear() + '' + monthString + '' + dayString;

                return angular.isDefined(scope.events[dateString]);
            };

            scope.getEventsOnDate = function(day) {
                var monthString = (scope.month.getMonth() + 1) > 9 ? scope.month.getMonth() + 1 : ('0' + (scope.month.getMonth() + 1)),
                    dayString = day > 9 ? day : ('0' + day),
                    dateString = scope.month.getFullYear() + '' + monthString + '' + dayString;

                return scope.events[dateString];
            };

            function setScopeCurrentMonth() {
                scope.monthName = eventsCalendarConfig.months[scope.month.getMonth()];
                scope.monthArray = getMonthArray(scope.month);
            }
        }
    };
});